export default "__VITE_ASSET__db30b6bd__"